module.exports = __webpack_public_path__ + "static/media/qitaf.60306b2f.svg";